"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TableRemoveIcon = (_a) => {
    var { size, color } = _a, rest = __rest(_a, ["size", "color"]);
    return (react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", version: "1.1", width: size || '1em', height: size || '1em', fill: color || 'currentColor', viewBox: "0 0 24 24" }, rest),
        react_1.default.createElement("path", { d: "M15.46,15.88l1.42-1.42L19,16.59l2.12-2.13l1.42,1.42L20.41,18l2.13,2.12l-1.42,1.42L19,19.41l-2.12,2.13l-1.42-1.42L17.59,18L15.46,15.88 M4,3h14c1.105,0,2,0.895,2,2v7.08c-1.55-0.26-3.08,0.1-4.32,0.92H12v4h1.08c-0.11,0.68-0.11,1.35,0,2H4\n\tc-1.105,0-2-0.895-2-2V5C2,3.895,2.895,3,4,3 M4,7v4h6V7H4 M12,7v4h6V7H12 M4,13v4h6v-4H4z" })));
};
exports.default = TableRemoveIcon;
